import { Link, NavLink } from "react-router-dom";
import { ShoppingBag } from "lucide-react";

const Header = () => {
  const linkStyle = ({ isActive }) => ({
    fontSize: 15,
    fontWeight: isActive ? 600 : 500,
    color: isActive ? "#0F766E" : "#111827",
    textDecoration: "none",
  });

  return (
    <header
      data-testid="site-header"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 64,
        background: "#FFFFFF",
        borderBottom: "1px solid #E5E7EB",
        zIndex: 50,
      }}
    >
      <div
        className="container-vzor"
        style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Link
          to="/"
          data-testid="brand-wordmark"
          style={{
            fontSize: 22,
            fontWeight: 700,
            color: "#0F766E",
            letterSpacing: "-0.01em",
            textDecoration: "none",
          }}
        >
          VZOR
        </Link>

        <nav style={{ display: "flex", alignItems: "center", gap: 24 }}>
          <NavLink to="/sunglasses" style={linkStyle} data-testid="nav-sunglasses">
            Sunglasses
          </NavLink>
          <NavLink to="/eyeglasses" style={linkStyle} data-testid="nav-eyeglasses">
            Eyeglasses
          </NavLink>
          <button
            aria-label="Cart"
            data-testid="cart-icon"
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              color: "#111827",
              padding: 6,
            }}
          >
            <ShoppingBag size={20} />
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
